import axios from 'axios';
import buildPaginationQueryOpts from '@/shared/sort/sorts';
import { IElbResource } from '@/shared/model/elb-resource.model';
import { ResourceInterface } from '@/shared/component/resource.interface';

const baseApiUrl = 'api/private/elb-resources';

export default class ElbResourceService implements ResourceInterface {
  public find(id: number): Promise<IElbResource> {
    return new Promise<IElbResource>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public create(entity: IElbResource): Promise<IElbResource> {
    return new Promise<IElbResource>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public update(entity: IElbResource): Promise<IElbResource> {
    return new Promise<IElbResource>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
